<template>
  <!-- 协会章程 -->
  <div class="box index-less">
    <details-head img="./img/bj3.png" title="协会章程" remarks="Articles Association" />
    <TopBreadcrumb :data="[{ label: '规划协会' }, { label: '协会章程' }]" />
    <div class="con">
      <!-- <TopTab /> -->
      <div class="box">
        <div class="left">
          <Left title="协会章程" remarks="Articles of Association"/>
        </div>
        <div class="right">
          <right-item v-for="item,i in data" :key="i" :title="item.title" :context="item.context" />
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import DetailsHead from "../../components/DetailsHead.vue";
import TopBreadcrumb from "../../components/TopBreadcrumb.vue";
import Left from "./comp/Left.vue";
import RightItem from "./comp/RightItem.vue";
import TopTab from "./comp/TopTab.vue";
import "./comp/index.less";
export default {
  name: "Home",
  components: { DetailsHead, TopBreadcrumb, Left, RightItem, TopTab },
  data() {
    return {
      data: [
        {
          title: "第一章 总 则",
          context:
            "本会是由广州市属行政区域内，不分所有制的工程勘察设计行业及相关企业以单位会员名义和施工图设计文件审查机构以单位会员名义自愿组成的工程勘察设计行业性、非营利性社会团体法人。"
          },
        {
          title: "第二章 会员",
          context:
            "持有国家或省建设行政主管部门颁发的勘察设计（含专项设计）资质证书或广东省建设行政主管部门认定的施工图设计文件审查认定书，且持有工商行政管理机关发给的营业执照的单位；",
        },
        {
          title: "第三章 业务范围和活动原则",
          context:"开展业务培训工作，举办各项技术宣贯和讲座，组织观摩和考察，大力推广新技术、新工艺、新材料，不断提高行业的技术素质和业务水平。"
        },
        {
          title: "第四章 业务范围和活动原则",
          context: "开展勘察设计行业社会团体间的交流与合作。加强与兄弟省市及港、澳、台地区社会组织的联系，促进友好交流。"
        },
        {
          title: "第五章 党建工作",
          context:"本会坚持中国共产党的全面领导，根据中国共产党章程的规定，设立中国共产党的组织，开展党的活动，为党组织的活动提供必要条件。凡是有正式党员三人以上的，经上级党组织批准，分别设立党委、总支、支部，并按期进行换届。如暂不能单独建立党组织，支持通过联合建立党组织或由上级党组织选派党建工作指导员等方式，在本组织开展党的工作。"
        },
        {
          title: "第六章 组织机构",
          context:"本会实行民主办会。领导机构的产生和重大事项的决策，须经民主表决通过，按少数服从多数的原则作出决定。"
        },
      ],
    };
  },
  methods: {},
};
</script>
 
<style lang="less" scoped>
.con .box .right {
  display: flex;
  flex-direction: column;
  gap: 13px;
}
</style>